import {
  META,
  META_DIMENSIONS,
  GRANULARITY,
  META_DIMENSIONS_ITEMS_SEARCH,
  CREATE_NAMED_QUERY,
} from "./../QueryBuilderQueries";

export const ELEMENT_TYPES = [
  { type: "metrics", query: META },
  { type: "dimensions", query: META_DIMENSIONS },
  { type: "dimensions_items", query: META_DIMENSIONS_ITEMS_SEARCH },
  { type: "granularity", query: GRANULARITY },
  { type: "create_named_query", query: CREATE_NAMED_QUERY },
];
